import { UPDATE_EVENTS } from "./types";

const updateEvents = (events) => ({
  type: UPDATE_EVENTS,
  events,
});

export default updateEvents;
